import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.admin.pacs.upsert.data = { ...data };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.admin.pacs.upsert = { ...state.admin.pacs.upsert, ...data };
  });
};

const upsert = async (store, meta, id) => {
  store.setState((state) => {
    state.admin.pacs.upsert.busy = true;
    state.admin.pacs.upsert.error = undefined;
    state.admin.pacs.upsert.result = undefined;
  });

  try {
    let response;

    let body = {
      ...meta,
      config: typeof meta.config === 'string' ? JSON.parse(meta.config) : meta.config,
    };

    if (!id) {
      response = await Http.post(`api/pacs`, body);
    } else {
      response = await Http.put(`api/pacs/${id}`, {
        ...body,
        hits: undefined,
      });
    }

    store.setState((state) => {
      state.admin.pacs.upsert.busy = false;
      state.admin.pacs.upsert.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.pacs.upsert.error = error.data || error;
      state.admin.pacs.upsert.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.admin.pacs.upsert.error = undefined;
};

const reset = (store) => (state) => {
  state.admin.pacs.upsert = { ...initialState };
};

const actions = {
  setData,
  change,
  upsert,
  resetError,
  reset,
};

const PacsUpsertStore = {
  state: () => initialState,
  actions,
};

export default PacsUpsertStore;
